module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2025-12-10 at 22.56.33 (5).901a0262.jpeg";